// Certificate template registry — each template overrides the title,
// subtitle body copy, and default subline of the base SVG builder.

export const CERT_TEMPLATES = [
    {
        id: "founding_member",
        label: "Founding Member",
        titleTop: "CERTIFICATE OF",
        titleBottom: "Founding Membership",
        defaultSubline: "Earth Guardian",
        body: [
            "In recognition of your early and enduring commitment to the mission",
            "of the EVIQ Earth Initiative — planting forests, restoring oceans,",
            "extending battery life, and rewiring veteran careers — you are",
        ],
        italicFooter: "hereby named a Founding Earth Guardian of EVIQ.",
        serial: "FOUNDING EARTH GUARDIAN",
        medallionLabel: "EARTH GUARDIAN",
    },
    {
        id: "launch_partner",
        label: "Launch Partner",
        titleTop: "CERTIFICATE OF",
        titleBottom: "Launch Partnership",
        defaultSubline: "The Gold Standard",
        body: [
            "In recognition of your distinguished commitment to the enduring health",
            "of the electric vehicle, and to the batteries, forests, oceans, and",
            "communities that our members are helping to protect — you are hereby",
        ],
        italicFooter: "named a founding Launch Partner of the EVIQ Earth Initiative.",
        serial: "No. 001 · LAUNCH PARTNER",
    },
    {
        id: "lifetime_patron",
        label: "Lifetime Patron",
        titleTop: "CERTIFICATE OF",
        titleBottom: "Lifetime Patronage",
        defaultSubline: "In Perpetuum",
        body: [
            "In enduring recognition of your commitment to the mission of the",
            "EVIQ Earth Initiative — every forest restored, every battery kept",
            "in service, every clean-energy career made possible — you are",
        ],
        italicFooter: "hereby honored as a Lifetime Patron of the EVIQ Earth Initiative.",
        serial: "Lifetime Patron",
    },
    {
        id: "cohort_sponsor",
        label: "Cohort Sponsor",
        titleTop: "CERTIFICATE OF",
        titleBottom: "Cohort Sponsorship",
        defaultSubline: "Veteran Green Careers",
        body: [
            "In grateful recognition of your sponsorship of a cohort of veterans",
            "transitioning into clean-energy careers — the training hours funded,",
            "the classrooms lit, the futures redirected — you are hereby",
        ],
        italicFooter: "acknowledged as a Cohort Sponsor of the EVIQ Earth Initiative.",
        serial: "Cohort Sponsor",
    },
];

export const getTemplate = (id) =>
    CERT_TEMPLATES.find((t) => t.id === id) || CERT_TEMPLATES[0];
